import { ScheduleTimeAvailableData } from "../../core/http/service/SchedulingService";
import AttendantSchedulingCard from "./AttendantSchedulingCard";

export interface SchedulingCardProp {
  data: ScheduleTimeAvailableData;
}

const SchedulingCard = ({ data }: SchedulingCardProp) => {
  const { unidadesAtendimento } = data;

  return (
    <>
      {unidadesAtendimento.map((value) => (
        <AttendantSchedulingCard {...value} data={data} />
      ))}
    </>
  );
};

export default SchedulingCard;
